import { startOfDay, subDays } from 'date-fns';

import { formatIsoLocalDate, formatIsoLocalDateTime } from '@townsquare/date-utils/format';
import { tzDate, tzWorkspaceTimezoneDate } from '@townsquare/date-utils/utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';
import { tqlQueryFromInput } from '@townsquare/tql/query';
import { ComparatorOperator } from '@townsquare/tql/types';

import GoalUpdatesAsideViewAggQueryNode, {
	type GoalUpdatesAsideViewAggQuery,
} from '../GoalUpdatesView/agg/__generated__/GoalUpdatesAsideViewAggQuery.graphql';

export const goalUpdatesAsideAggResource = createRelayResource<GoalUpdatesAsideViewAggQuery>({
	getQuery: (_routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const sidebarStartDate = formatIsoLocalDateTime(subDays(startOfDay(tzDate()), 7));
		const sidebarEndDate = formatIsoLocalDateTime(tzDate());

		const ownGoalsSearchString = tqlQueryFromInput({
			input: [
				{
					fieldName: 'owner',
					fieldValue: context.user.accountId,
					comparator: ComparatorOperator.EQUALS,
				},
				{ fieldName: 'archived', fieldValue: false, comparator: ComparatorOperator.EQUALS },
			],
		});
		const newGoalsSearchString = tqlQueryFromInput({
			input: [
				{
					fieldName: 'creationDate',
					fieldValue: sidebarStartDate,
					comparator: ComparatorOperator.GTE,
				},
				{
					fieldName: 'creationDate',
					fieldValue: sidebarEndDate,
					comparator: ComparatorOperator.LTE,
				},
				{ fieldName: 'archived', fieldValue: false, comparator: ComparatorOperator.EQUALS },
			],
		});
		const completedGoalsSearchString = tqlQueryFromInput({
			input: [
				{ fieldName: 'archived', fieldValue: false, comparator: ComparatorOperator.EQUALS },
				{ fieldName: 'phase', fieldValue: 'done', comparator: ComparatorOperator.EQUALS },
				{
					fieldName: 'targetDate',
					fieldValue: formatIsoLocalDate(tzWorkspaceTimezoneDate(sidebarStartDate)),
					comparator: ComparatorOperator.GTE,
				},
				{
					fieldName: 'targetDate',
					fieldValue: formatIsoLocalDate(tzWorkspaceTimezoneDate(sidebarEndDate)),
					comparator: ComparatorOperator.LTE,
				},
			],
		});

		return {
			query: GoalUpdatesAsideViewAggQueryNode,
			variables: {
				containerId: context.collabContext?.contextId || '',
				ownGoalsSearchString,
				newGoalsSearchString,
				completedGoalsSearchString,
			},
			cacheKey: 'goalUpdatesAsideAgg',
			options: {
				fetchPolicy: 'store-and-network',
			},
			environment: getAggRelayEnvironment(),
		};
	},
});
